<a (click)="print()"
class="calendar__print calendar__icon-link"
>
<div class="calendar__icon-wrapper">
  <mat-icon svgIcon="print"></mat-icon>
</div>Print
</a>
